import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=7db618c4&scoped=true&lang=pug"
import script from "./PaginationComponent.vue?vue&type=script&lang=ts"
export * from "./PaginationComponent.vue?vue&type=script&lang=ts"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=7db618c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db618c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db618c4')) {
      api.createRecord('7db618c4', component.options)
    } else {
      api.reload('7db618c4', component.options)
    }
    module.hot.accept("./PaginationComponent.vue?vue&type=template&id=7db618c4&scoped=true&lang=pug", function () {
      api.rerender('7db618c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pagination/PaginationComponent.vue"
export default component.exports